export const movies = [
  {
    id: "m01",
    title: "星际回响",
    genre: "科幻",
    rating: 9.2,
    year: 2024,
    duration: "128分钟",
    tagline: "来自深空的信号，改写了一整代人的命运。",
    description:
      "一名深空观测员在近乎退役的年纪收到一段无法解释的回响信号。影片用克制的节奏铺开对未知的敬畏，没有堆砌特效，却把孤独、信念与人类好奇心拍得极为动人。",
    highlights: ["视觉质感出色", "节奏沉稳", "适合大屏观看"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%20of%20a%20lone%20astronaut%20silhouette%20facing%20a%20vast%20glowing%20cosmic%20nebula%2C%20deep%20space%20atmosphere%2C%20dramatic%20rim%20lighting%2C%20muted%20amber%20and%20charcoal%20tones%2C%20grainy%20film%20texture%2C%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=movie-poster-scifi-01&orientation=portrait",
  },
  {
    id: "m02",
    title: "长夜将尽",
    genre: "悬疑",
    rating: 8.9,
    year: 2023,
    duration: "115分钟",
    tagline: "每一个细节，都在指向同一场雨夜。",
    description:
      "雨夜、路灯、一把丢失的钥匙，构成了一场精巧的推理游戏。影片把线索藏在日常的对话里，越到后半段越让人坐不住，适合喜欢边看边推理的观众。",
    highlights: ["线索严谨", "反转自然", "氛围极佳"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20noir%20mystery%20movie%20poster%20art%20of%20a%20rain-soaked%20city%20street%20at%20midnight%20with%20a%20solitary%20figure%20under%20a%20streetlamp%2C%20moody%20shadows%2C%20warm%20amber%20glow%20and%20dark%20tones%2C%20film%20grain%2C%20minimal%20composition&width=400&height=600&seq=movie-poster-noir-02&orientation=portrait",
  },
  {
    id: "m03",
    title: "山河故人梦",
    genre: "剧情",
    rating: 9.0,
    year: 2022,
    duration: "142分钟",
    tagline: "山还是那座山，人已经走远了。",
    description:
      "以三个时间段落串起一个家庭的离散与重逢，导演把镜头交给山野与炊烟，情绪几乎全靠留白传达。看完会安静很久，是适合一个人认真观看的作品。",
    highlights: ["表演细腻", "时间长卷", "后劲很足"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20art%20of%20rolling%20misty%20mountains%20at%20dawn%20with%20a%20small%20village%20and%20a%20winding%20path%2C%20nostalgic%20warm%20golden%20light%2C%20painterly%20texture%2C%20quiet%20poetic%20atmosphere%2C%20high%20detail&width=400&height=600&seq=movie-poster-drama-03&orientation=portrait",
  },
  {
    id: "m04",
    title: "雾都迷踪",
    genre: "犯罪",
    rating: 8.7,
    year: 2024,
    duration: "121分钟",
    tagline: "雾散得越慢，真相就越近。",
    description:
      "港口城市的一桩旧案牵出一条完整的黑色链条，警方线与商人线双线并进。影片的冷峻摄影和低饱和色调，把整座城市的压抑感拍了出来。",
    highlights: ["双线叙事", "摄影冷峻", "群像扎实"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20art%20of%20a%20foggy%20industrial%20harbor%20at%20night%20with%20silhouettes%20of%20ships%20and%20cranes%2C%20moody%20amber%20lights%2C%20mysterious%20atmosphere%2C%20film%20grain%2C%20muted%20tones&width=400&height=600&seq=movie-poster-crime-04&orientation=portrait",
  },
  {
    id: "m05",
    title: "烈日长风",
    genre: "动作",
    rating: 8.5,
    year: 2023,
    duration: "133分钟",
    tagline: "有些路，只能一直往前开。",
    description:
      "一场横跨公路的追逃，把动作场面拍得干净利落，没有多余的花哨镜头。主角的动机清晰，节奏几乎全程在线，是周末放松的稳妥选择。",
    highlights: ["场面利落", "节奏紧凑", "爽感充足"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20art%20of%20a%20rugged%20desert%20highway%20at%20blazing%20sunset%20with%20a%20lone%20car%20speeding%20and%20a%20dust%20trail%2C%20dramatic%20warm%20orange%20sky%2C%20energetic%20composition%2C%20film%20grain%2C%20high%20detail&width=400&height=600&seq=movie-poster-action-05&orientation=portrait",
  },
  {
    id: "m06",
    title: "春日便利店",
    genre: "爱情",
    rating: 8.3,
    year: 2024,
    duration: "108分钟",
    tagline: "所有的喜欢，都发生在深夜的灯下。",
    description:
      "两个夜班店员在便利店相识，故事几乎都发生在小小的店堂里。影片把暧昧拍得轻盈又真诚，配乐温柔，是那种看完会想给人发消息的电影。",
    highlights: ["对白自然", "氛围温柔", "轻松治愈"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20art%20of%20a%20cozy%20corner%20convenience%20store%20at%20dusk%20with%20warm%20glowing%20windows%20and%20cherry%20blossoms%2C%20soft%20pastel%20warm%20tones%2C%20gentle%20nostalgic%20mood%2C%20film%20grain&width=400&height=600&seq=movie-poster-romance-06&orientation=portrait",
  },
  {
    id: "m07",
    title: "深海信标",
    genre: "科幻",
    rating: 8.8,
    year: 2025,
    duration: "136分钟",
    tagline: "海面之下，有人还在等一个回应。",
    description:
      "深海科考站与陆地失联后，值守员依靠一台老信标维持联系。影片把封闭空间里的紧张感经营得非常出色，同时保留了温柔的人情底色。",
    highlights: ["封闭空间", "张力十足", "情感克制"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%20of%20a%20deep%20ocean%20underwater%20research%20station%20with%20glowing%20lights%20and%20dark%20water%2C%20a%20beacon%20beam%20cutting%20through%20darkness%2C%20mysterious%20atmosphere%2C%20amber%20accents%2C%20film%20grain&width=400&height=600&seq=movie-poster-deepsea-07&orientation=portrait",
  },
  {
    id: "m08",
    title: "无声证词",
    genre: "悬疑",
    rating: 9.1,
    year: 2023,
    duration: "118分钟",
    tagline: "最沉默的人，往往知道最多。",
    description:
      "一桩看似简单的案件，因为一位不肯开口的证人而变得复杂。影片用大量留白和光影对比制造压迫感，台词精炼，结局利落。",
    highlights: ["表演出色", "光影讲究", "结局利落"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20movie%20poster%20art%20of%20an%20empty%20courtroom%20corridor%20with%20long%20shadows%20and%20a%20single%20window%20light%2C%20dramatic%20chiaroscuro%2C%20muted%20warm%20amber%20and%20dark%20tones%2C%20film%20grain%2C%20tense%20atmosphere&width=400&height=600&seq=movie-poster-suspense-08&orientation=portrait",
  },
  {
    id: "m09",
    title: "归途列车",
    genre: "剧情",
    rating: 8.6,
    year: 2022,
    duration: "125分钟",
    tagline: "开往故乡的车，总是慢一点。",
    description:
      "一位多年未归的中年人坐上返乡的绿皮车，与同车旅客发生了一段短暂的相处。影片用极其生活化的细节，讲清了关于和解与告别的事。",
    highlights: ["细节动人", "生活质感", "适合静看"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20art%20of%20an%20old%20train%20crossing%20a%20vast%20wheat%20field%20at%20golden%20hour%2C%20warm%20nostalgic%20light%2C%20lonely%20poetic%20mood%2C%20painterly%20film%20texture%2C%20high%20detail&width=400&height=600&seq=movie-poster-train-09&orientation=portrait",
  },
  {
    id: "m10",
    title: "百鬼夜行帖",
    genre: "奇幻",
    rating: 8.2,
    year: 2024,
    duration: "110分钟",
    tagline: "灯笼亮起的时候，别回头。",
    description:
      "以一场古镇灯会为舞台，把民间传说和现代叙事缝在一起。美术与灯光设计是全片亮点，适合喜欢东方奇幻美学的观众。",
    highlights: ["美术出彩", "东方美学", "想象力足"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20movie%20poster%20art%20of%20a%20lantern-lit%20ancient%20street%20festival%20at%20night%20with%20mysterious%20glowing%20spirits%2C%20warm%20red%20and%20amber%20lanterns%2C%20dark%20background%2C%20rich%20mysterious%20atmosphere%2C%20film%20grain&width=400&height=600&seq=movie-poster-fantasy-10&orientation=portrait",
  },
  {
    id: "m11",
    title: "铁血长风渡",
    genre: "战争",
    rating: 8.9,
    year: 2021,
    duration: "147分钟",
    tagline: "渡过去，就是家。",
    description:
      "以一场渡河战役为切口，聚焦普通士兵的选择与牺牲。影片没有刻意煽情，战斗调度扎实，人物群像立得住，情绪后劲很强。",
    highlights: ["群像扎实", "调度出色", "情绪厚重"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20war%20movie%20poster%20art%20of%20soldier%20silhouettes%20crossing%20a%20river%20at%20dawn%20with%20smoke%20and%20a%20dramatic%20sky%2C%20solemn%20heroic%20mood%2C%20desaturated%20warm%20tones%2C%20film%20grain%2C%20high%20detail&width=400&height=600&seq=movie-poster-war-11&orientation=portrait",
  },
  {
    id: "m12",
    title: "云上小镇",
    genre: "动画",
    rating: 9.3,
    year: 2023,
    duration: "96分钟",
    tagline: "把愿望装进气球，就能飞起来。",
    description:
      "一座漂浮在云层之上的小镇，和一个想找回名字的小女孩。手绘质感的画面温暖明亮，故事简单却真诚，适合全家一起观看。",
    highlights: ["画风治愈", "老少皆宜", "配乐动听"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20movie%20poster%20art%20of%20a%20whimsical%20floating%20town%20above%20soft%20clouds%20with%20colorful%20balloons%20and%20warm%20sunset%20light%2C%20dreamy%20hand-painted%20style%2C%20gentle%20joyful%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-animation-12&orientation=portrait",
  },
];